
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcEventList as ObcEventListElement} from '@oicl/openbridge-webcomponents/dist/components/event-list/event-list.js';
 
 
 

 
 export const ObcEventList = createComponent({
   react: React,
   tagName: 'obc-event-list',
   elementClass: ObcEventListElement,
   events: {
     
   }
  });
 
 